export const environment = {
  production: true,
  auth: {
    redirectUri: 'https://dev-customers.mtjr.ly/',
    postLogoutRedirectUri: 'https://dev-customers.mtjr.ly/',
    resource: 'https://customers.mtjr.ly',
  },
  baseUrl: 'https://dev-capi.mtjr.ly',
  shareBaseUrl: 'https://dev-share.mtjr.ly',
  moamalatUrl: 'https://tnpg.moamalat.net:6006/',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).appEnv = environment;
